export default __webpack_public_path__ + "static/media/scanner.439ce0b2.png";